import styled from "styled-components";
import { Text } from "venice-ui";
import { Colors } from "../../untils/Theme";

export const MapHeaderWrapper = styled.div`
  margin-bottom: 0.8rem;
  width: 100%;
  justify-content: space-between;
  padding: 0px;
  width: 100%;
  align-items: center;
  flex-direction: row;
  display: flex;
`;

export const ZoomSection = styled.div`
  display: flex;
  gap: 0.2rem;
  flex-wrap: wrap;
`;
export const ZoomScale = styled.div`
  font-size: 1.4rem;
  padding: 0.4rem 0.8rem;
  width: 65px;
  text-align: right;
  overflow: hidden;
`;

export const SectionHeaderWrapper = styled.div`
  height: 52px;
  box-sizing: border-box;
  display: flex;
  padding: 8px 16px;
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const TextBold = styled(Text)`
  font-weight: bold;
`;

export const SectionHeaderIcon = styled.div`
  width: 2rem;
  height: 2rem;
  background-color: ${Colors.appBlueAccent};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;


export const ZoomIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  background-color: ${Colors.appBlueAccent};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
